import { defineStore } from 'pinia';
import { createPopulateString, parseCollectionData } from '~/utils/strapiComponents/addStrapiData';
import { processBannerRules } from '~/utils/strapiComponents/filters';
import { strapi } from '../transport/strapi';
import type { IBonusBannerData, IBonusBannerStrapiResponse } from '~/types/banners';

export const useStoreBonusesBanners = defineStore('bonusesBanners', {
  state: () => ({
    banners: [] as IBonusBannerData[],
    requestPromise: null as Promise<IBonusBannerStrapiResponse> | null,
  }),

  getters: {
    personalList(state): IBonusBannerData[] {
      return state.banners.filter((banner): boolean =>
        banner.bannerRules?.length ? processBannerRules(banner.bannerRules) : true
      );
    },
  },

  actions: {
    async loadBonusesBanners() {
      if (!this.requestPromise) {
        const populateString = createPopulateString([
          'bannerRules',
          'bannerCardFront',
          'bannerCardBack',
          'bannerAction',
          'bannerAction.params',
        ]);

        this.requestPromise = strapi()
          .get('bonuses-banners', populateString)
          .finally(() => (this.requestPromise = null));
      }

      const response = await this.requestPromise;

      if (response?.data) {
        const parsedData = parseCollectionData(response.data);
        const filteredState = this.banners.filter(
          (item) => !parsedData.find(({ id }) => id && id === item.id)
        );

        this.banners = [...filteredState, ...parsedData].sort((a, b) => a.position - b.position);

        return true;
      } else {
        return false;
      }
    },
    SET_BONUSES_BANNERS(data: IBonusBannerData[]) {
      const parsedData = parseCollectionData(data);
      const filteredState = this.banners.filter(
        (item) => !parsedData.find(({ id }) => id && id === item.id)
      );

      this.banners = [...filteredState, ...parsedData].sort((a, b) => a.position - b.position);
    },
  },
});
